import React from 'react';

export function Singapore(props) {
  return (
    <svg width="513" height="342" viewBox="0 0 513 342" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0H513V171H0V0Z" fill="#EF3340"/>
      <path d="M0 171H513V342H0V171Z" fill="white"/>
      <path d="M75,86 C75,56 100,34 125,41 C110,51 103,66 105,86 C103,106 110,121 125,131 C100,138 75,116 75,86Z" fill="white"/>
      <circle cx="117" cy="58" r="8" fill="white"/>
      <circle cx="135" cy="45" r="8" fill="white"/>
      <circle cx="155" cy="48" r="8" fill="white"/>
      <circle cx="163" cy="68" r="8" fill="white"/>
      <circle cx="148" cy="82" r="8" fill="white"/>
    </svg>
  );
}
